module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2026-08-05 at 10.39.01 (3).29777959.jpeg";